<div class="authentification">
    <div class="d-lg-flex align-items-center">
        <div class="col-lg-6" style="padding: 48px 156px 20px 156px; background-color: #fff !important;">
            <div class="w-desktop">
                <!-- second part  -->
                <div class="col-md-6 col-sm-6 col-xs-6">
                    <div class="row head">
                        <div class="col-md-11 col-sm-11 col-xs-11 " style="margin-bottom: 80px;">
                            <a href="/"><img src="../../../assets/images/conversell-logo.png" alt="Conversell"></a>
                        </div>
                    </div>
                </div>
                <h1>One more step</h1>
                <span class="descTitle"> One more step to finish set up your account. </span>
                <div class=" pr-2 mx-auto mt-3 mb-3">
                    <form class="card_design" [formGroup]="userMoreDetailForm" (ngSubmit)="submitted = true">
                        <div class="form-group">
                            <label class="Label__Text">Full Name </label>
                            <div>
                                <input pInputText formControlName="name" required placeholder="Enter your full name"
                                    minlength="3" maxlength="50" pattern="^[A-Za-zÀ-ÿ\s'-]+$" />
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['name'].touched && userMoreDetailForm.controls['name'].hasError('required')">
                                    This field is required.
                                </mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['name'].touched && userMoreDetailForm.controls['name'].hasError('minlength')">
                                    Minimum 3 characters.
                                </mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['name'].touched && userMoreDetailForm.controls['name'].hasError('maxlength')">
                                    Maximum 50 characters.
                                </mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['name'].touched && userMoreDetailForm.controls['name'].hasError('pattern')">
                                    Only letters are allowed.
                                </mat-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="Label__Text">Phone Number </label>
                            <div>
                                <input pInputText formControlName="cell" type="tel" required
                                    placeholder="Enter your phone number" pattern="^[0-9]*$" minlength="8"
                                    maxlength="15" />
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['cell'].touched && userMoreDetailForm.controls['cell'].hasError('required')">
                                    This field is required.
                                </mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['cell'].touched && userMoreDetailForm.controls['cell'].hasError('pattern')">
                                    Only digits are allowed.
                                </mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['cell'].touched && userMoreDetailForm.controls['cell'].hasError('minlength')">
                                    Minimum 8 digits.
                                </mat-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="Label__Text">Company Name</label>
                            <div>
                                <input pInputText formControlName="company" placeholder="Enter your company name"
                                    type="text" required minlength="2" maxlength="100" />
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['company'].touched && userMoreDetailForm.controls['company'].hasError('required')">
                                    This field is required.
                                </mat-error>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="Label__Text">Workspace URL</label>
                            <div>
                                <input pInputText formControlName="site" placeholder="Enter your workspace URL"
                                    pattern="https?://.+" required />
                                <mat-error
                                    *ngIf=" submitted &&userMoreDetailForm.controls['site'].hasError('required')">This
                                    field is required.</mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['site'].touched && userMoreDetailForm.controls['site'].hasError('required')">
                                    This field is required.
                                </mat-error>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['site'].touched && userMoreDetailForm.controls['site'].hasError('pattern')">
                                    Please provide a valid URL.
                                </mat-error>
                                <ng-container *ngIf="userMoreDetailForm.controls['platform'].value === 'shopify'">
                                    <mat-error
                                        *ngIf="userMoreDetailForm.controls['site'].touched && userMoreDetailForm.controls['site'].errors?.['pattern']">
                                        Please enter a valid Shopify URL<br> (e.g., https://storename.myshopify.com)
                                    </mat-error>
                                </ng-container>
                            </div>
                        </div>
                        <!-- Country -->
                        <div class="form-group">
                            <label class="Label__Text">Country </label>
                            <div class="country">
                                <mat-select matInput class="mat-form-field" placeholder="Select a country"
                                    formControlName="country" required (selectionChange)=onTypeChange($event.value)>
                                    <mat-option *ngFor="let country of countries"
                                        [value]="country.name">{{country.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['country'].touched && userMoreDetailForm.controls['country'].hasError('required')">
                                    This field is required.
                                </mat-error>
                            </div>
                        </div>
                        <!-- Platform -->
                        <div class="form-group">
                            <label class="Label__Text">Select Platform</label>
                            <div class="platform">
                                <mat-select matInput placeholder="Select your platform" formControlName="platform"
                                    required>
                                    <mat-option *ngFor="let platform of platforms"
                                        [value]="platform.value">{{platform.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="userMoreDetailForm.controls['platform'].touched && userMoreDetailForm.controls['platform'].hasError('required')">
                                    This field is required.
                                </mat-error>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="btn-1">
                                <!-- [disabled]="!userMoreDetailForm.valid" -->
                                <button [disabled]="userMoreDetailForm.invalid" (click)="registerDetailClient()"
                                    class="d-block text-center w-100">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- <div class="row">
              <div class="text_term-privacy">
                 <p>
                     By clicking “Submit”, you acknowledge that you have read and understood, 
                     and agree to Conversell's <a href="https://www.conversell.ai/terms-of-use.html" target="_blank"> "Terms of use" </a>  and <a target="_blank" href="https://www.conversell.ai/privacy-policy-solution.html"> "Privacy Policy" </a> 
                 </p>
              </div>
            </div> -->
            </div>
        </div>
        <div class="col-lg-6 text-lg-end">
            <img src="../../../../../assets/images/screen_mockup.png" alt="">
        </div>
    </div>
</div>